
<div class="content">
  <div class="container">
    <div class="wrap">
      <h1>
        <span>... 404 error ...</span>
      Sorry, page not <br>found
      </h1>

      <button class="btn" (click)="goToHome()">
        Back to home
      </button>
    </div>
  </div>
</div>

